export class formSubmitDirective {
	constructor() {
		let formSubmitObj: ng.IDirective = {};
		formSubmitObj.restrict = 'A';
		formSubmitObj.link = (scope, elem) => {
			elem.on('submit', function () {
				// find the first invalid element
				var firstInvalid = elem[0].querySelector('.ng-invalid') as HTMLElement;

				// if we find one, set focus
				if (firstInvalid) {
					firstInvalid.focus();
				}
			});
		}
		return formSubmitObj;
	}
}